"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../request/index");
var API = /** @class */ (function () {
    function API(config, instance) {
        this.PID = config.pid;
        this.lfRequest = (0, index_1.requestFn)(instance);
    }
    API.prototype.login = function (params) {
        return this.lfRequest("/api/base/".concat(this.PID, "/login"), "POST", "multipart/form-data", null, params);
    };
    API.prototype.logout = function () {
        return this.lfRequest("/api/base/".concat(this.PID, "/logout"), "POST", "multipart/form-data", null, null);
    };
    API.prototype.getList = function (params, fileds) {
        return this.lfRequest("/api/base/".concat(this.PID, "/list"), "POST", "application/json", params, fileds);
    };
    API.prototype.getDetail = function (id) {
        return this.lfRequest("/api/base/".concat(this.PID, "/").concat(id), "GET", "multipart/form-data");
    };
    API.prototype.deleteData = function (id) {
        return this.lfRequest("/api/base/".concat(this.PID, "/").concat(id), "DELETE", "multipart/form-data");
    };
    API.prototype.deleteMultiData = function (params) {
        return this.lfRequest("/api/base/".concat(this.PID), "DELETE", "application/json", null, params);
    };
    API.prototype.addData = function (params) {
        return this.lfRequest("/api/base/".concat(this.PID), "POST", "application/json", null, params);
    };
    API.prototype.updateData = function (id, params) {
        return this.lfRequest("/api/base/".concat(this.PID, "/").concat(id), "PUT", "application/json", null, params);
    };
    API.prototype.uploadFile = function (params) {
        return this.lfRequest("/api/".concat(this.PID), "POST", "multipart/form-data", null, params);
    };
    return API;
}());
exports.default = API;
